const enviroment = process.env.REACT_APP_ENV

export const isProduction = () => enviroment === 'production'
export const isHomol = () => enviroment === 'test'

export const getQuestionaryUrl = () => {
  if (isProduction()) {
    return process.env.REACT_APP_QUESTIONARY_PROD_URL
  }

  if (isHomol()) {
    return process.env.REACT_APP_QUESTIONARY_HOMOL_URL
  }

  return process.env.REACT_APP_QUESTIONARY_LOCAL_URL
}

export default { isHomol, isProduction, getQuestionaryUrl }
